import { Component } from '@theme/component';

/**
 * Tyhjä komponentti – poistaa ostoskorikuvakkeen toiminnallisuuden ja näkymisen.
 */
class CartIcon extends Component {
  connectedCallback() {
    // Piilottaa koko elementin heti kun se ladataan
    this.style.display = 'none';
  }
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}
